import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    Button,
    IconButton,
    Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ThemedButton } from '@awarego-ui/components';
import JsonFilterGroup from './JsonFilterGroup';

function AdvancedSearchModal({
    open,
    onClose,
    detailsFilters = [],
    contextFilters = [],
    detailsKeysOptions = [],
    contextKeysOptions = [],
    onApply,
}) {
    const [localDetailsFilters, setLocalDetailsFilters] = useState(detailsFilters);
    const [localContextFilters, setLocalContextFilters] = useState(contextFilters);

    // Reset local state when modal opens
    React.useEffect(() => {
        if (open) {
            setLocalDetailsFilters(detailsFilters.length > 0 ? detailsFilters : [{ key: '', operator: 'contains', value: '', matchCase: false, words: false }]);
            setLocalContextFilters(contextFilters.length > 0 ? contextFilters : [{ key: '', operator: 'contains', value: '', matchCase: false, words: false }]);
        }
    }, [open, detailsFilters, contextFilters]);

    const handleApply = () => {
        // Filter out empty filters
        // For exists/not_exists operators, value is not required
        const filterEmpty = (filters) => filters.filter(f => {
            if (!f.key) return false;
            const operator = f.operator || 'contains';
            // exists and not_exists don't need value
            if (operator === 'exists' || operator === 'not_exists') return true;
            // other operators need value
            return f.value || f.value === 0;
        });
        
        onApply({
            detailsFilters: filterEmpty(localDetailsFilters),
            contextFilters: filterEmpty(localContextFilters),
        });
        onClose();
    };

    const handleClear = () => {
        setLocalDetailsFilters([{ key: '', operator: 'contains', value: '', matchCase: false, words: false }]);
        setLocalContextFilters([{ key: '', operator: 'contains', value: '', matchCase: false, words: false }]);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    minHeight: 500,
                }
            }}
        >
            <DialogTitle sx={{ pb: 1 }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6" component="div">
                        Advanced Search
                    </Typography>
                    <IconButton
                        edge="end"
                        onClick={onClose}
                        aria-label="close"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <Divider />
            
            <DialogContent sx={{ pt: 3, pb: 2 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    <JsonFilterGroup
                        title="Details (Old/New Values)"
                        filters={localDetailsFilters}
                        onChange={setLocalDetailsFilters}
                        keyOptions={detailsKeysOptions}
                    />

                    <JsonFilterGroup
                        title="Context"
                        filters={localContextFilters}
                        onChange={setLocalContextFilters}
                        keyOptions={contextKeysOptions}
                    />
                </Box>
            </DialogContent>

            <Divider />
            <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
                <Button
                    onClick={handleClear}
                    variant="outlined"
                    size="medium"
                >
                    Clear All
                </Button>
                <Box sx={{ flexGrow: 1 }} />
                <ThemedButton
                    mode="secondary"
                    onClick={onClose}
                    text="Cancel"
                />
                <ThemedButton
                    mode="primary"
                    onClick={handleApply}
                    text="Apply Filters"
                />
            </DialogActions>
        </Dialog>
    );
}

export default AdvancedSearchModal;

